import Camera from './camera.svg';
import AlertIcon from './green-tick.svg';
import LeftArrow from './left-arrow.svg';
import DownArrow from './down-arrow.svg';
import RightArrow from './right-arrow.svg';
import Logo from './logo.svg';
import MenuIcon from './menu.svg';
import StoreIcon from './store.svg';
import UserIcon from './user.svg';
import WhiteTick from './white-tick.svg';
import CalendarIcon from './calendar.svg';
import AttachmentIcon from './attachment.svg';
import PdfIcon from './pdf.png';
import CsvIcon from './csv.png';
import NoInternetIcon from './no-internet.png';
import AppBrandingIcon from './app-branding.svg';
import LoginBranding from './login-branding.png';
import LoginBackground from '../login-background.jpg';
import LoginBackground2 from '../login_background.png';
import LoginBackground3 from '../login-background_2.png';
import LoginBackground4 from '../login-background_4.png';
import LoginBackground5 from '../login-background_5.png';
import LoginBgVideo from '../login-background.mp4';

const Images = {
  AlertIcon: AlertIcon,
  LeftArrow,
  WhiteTick,
  Warning: AlertIcon,
  Error: AlertIcon,
  ConfirmationModalIcon: AlertIcon,
  AskLocation: AlertIcon,
  CloseCircle: AlertIcon,
  GreenTickIcon: AlertIcon,
  RoundGreenTickIcon: AlertIcon,
  Logo,
  HeaderClose: AlertIcon,
  UserIcon,
  StoreIcon,
  Camera,
  CalendarIcon,
  AttachmentIcon,
  PdfIcon,
  CsvIcon,
  NoInternetIcon,
  AppBrandingIcon,
  LoginBranding,
  LoginBackground,
  LoginBgVideo,
  LoginBackground2,
  LoginBackground3,
  LoginBackground4,
  LoginBackground5,
};

const NavigationIcons = {
  Back: LeftArrow,
  Menu: MenuIcon,
  RightArrow,
  DownArrow,
};

export { NavigationIcons };
export default Images;
